import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";

// FIXME: Replace with a HttpContextToken
export const inMenCacheHeaderToken = "x-atc-cache";

export const inMemCacheResetHeaderToken = "x-atc-cache-reset";

@Injectable()
export class CacheInterceptor implements HttpInterceptor {

    readonly inMemCache = new Map<string, HttpResponse<any>>();

    constructor() {}    
    
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
 
        // FIXME: This a temporary solution for passign conditions to the HttpInterceptor.
        // in the future this should be replaced by an HttpContextToken. this new feature is
        // only available in v12. [see documentation here](https://angular.io/guide/http#passing-metadata-to-interceptors)
        const cacheableHeader = req.headers.has(inMenCacheHeaderToken);
        let finalReq = cacheableHeader ? 
            req.clone({ headers: req.headers.delete(inMenCacheHeaderToken) }) : 
            req;

        if(req.headers.has(inMemCacheResetHeaderToken)) {
            this.inMemCache.delete(req.url);
            finalReq = finalReq.clone({ headers: finalReq.headers.delete(inMemCacheResetHeaderToken) });
        }
        
        if(req.method !== "GET" || !cacheableHeader) {
            return next.handle(finalReq);
        }

        const cachedResponse = this.inMemCache.get(req.url);

        if (cachedResponse) {
            return of(cachedResponse.clone());
        }
        else {
            return next.handle(finalReq)
                .pipe(
                    tap(event => {
                        if (event instanceof HttpResponse) {
                            this.inMemCache.set(req.url, event.clone());
                        }
                    })
                );
        }
    }
}